import { render, staticRenderFns } from "./TicketsAgendados.vue?vue&type=template&id=e70d2b94&scoped=true"
import script from "./TicketsAgendados.vue?vue&type=script&lang=js"
export * from "./TicketsAgendados.vue?vue&type=script&lang=js"
import style0 from "./TicketsAgendados.vue?vue&type=style&index=0&id=e70d2b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70d2b94",
  null
  
)

export default component.exports